/* eslint-disable @khan/frontend/require-stories -- this is an internal component with nothing interesting to show in a story */
/**
 * A component that checks if the user is on a URL that belongs to a different
 * entrypoint, and reloads the page if so, allowing the page to render.
 */
import {useContext} from "react";
import {useLocation} from "react-router-dom-v5-compat";

import {AppShellContext} from "@khan/shared-core/context";

import ReloadPage from "../reload-page/reload-page.tsx";

import {shouldReload} from "./entrypoint-reload-check-utils.ts";

interface Props {
    children: React.ReactNode;
}

export default function EntrypointReloadCheck({children}: Props) {
    const {entrypoint} = useContext(AppShellContext);
    const {pathname} = useLocation();

    return shouldReload(entrypoint, pathname) ? <ReloadPage /> : children;
}
